import {writable} from "svelte/store";

export const docs = new writable([]);
export const turnos = new writable([]);
